import React from 'react';
import * as styles from './body-text.module.css';

const BodyText = ({ children, className, color, variant="bodyText6" }) => {
  const combinedClasses = `${styles[variant]} ${className || ''}`;

  return (
    <div className={combinedClasses} style={{ color: color }} >
      {children}
    </div>
  );
};

export default BodyText;